import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}ski/`,
  [],
  [authentication],
  [],
  false,
  120000,
  true,
);

export default {
  /**
   * @param searchSkiSchoolPrices
   * @returns {AxiosPromise}
   */
  searchAvailableSkiSchoolPrices(searchSkiSchoolPrices) {
    return conduit.post('school/search-available-prices', { searchSkiSchoolPrices });
  },

  /**
   * @param twentyAreaId
   * @returns {AxiosPromise}
   */
  loadSkiSchoolAreaPickupsBySeasonId(seasonId) {
    return conduit.get(`pickups/seasons/skischool/${seasonId}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/ski-school-service.js